import {proposalStatus} from "./constants";

const PRESENTATION_BY_STATUS = Object.freeze({
  [proposalStatus.INITIATED]: {
    label: "En attente",
    color: "#FF6600",
    backgroundColor: "#FFF2EA",
  },
  [proposalStatus.ACCEPTED]: {
    label: "Acceptée",
    color: "#FF6600",
    backgroundColor: "#FFF2EA",
  },
  [proposalStatus.REFUSED]: {
    label: "Refusée",
    color: "#D80027",
    backgroundColor: "#FFF0F2",
  },
  [proposalStatus.CANCELLED]: {
    label: "Annulée",
    color: "#D80027",
    backgroundColor: "#FFF0F2",
  },
  [proposalStatus.OFFER_HANDLED]: {
    label: "Déjà traitée",
    color: "#D80027",
    backgroundColor: "#FFF0F2",
  },
  [proposalStatus.INTERVENTION_DECLINED]: {
    label: "Intervention refusée",
    color: "#D80027",
    backgroundColor: "#FFF0F2",
  },
  [proposalStatus.INTERVENTION_CREATED]: {
    label: "Intervention confirmée",
    color: "#27AA00",
    backgroundColor: "#E9F9EC",
  },
  [proposalStatus.ENDED]: {
    label: "Intervention terminée",
    color: "#27AA00",
    backgroundColor: "#E9F9EC",
  },
  [proposalStatus.HIDDEN]: {
    label: "Masquée",
    color: "#7E7E7E",
    backgroundColor: "#F4F4F4",
  },
});

const DEFAULT_PRESENTATION = Object.freeze({
  label: "Statut indisponible",
  color: "#7E7E7E",
  backgroundColor: "#F4F4F4",
});

export const getProposalPresentation = (status) =>
  PRESENTATION_BY_STATUS[status] || DEFAULT_PRESENTATION;

export const isProposalPayable = (proposal) =>
  proposal?.status === proposalStatus.ACCEPTED && proposal?.isPaid !== true;
